import { useState, useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';

export default function AddTransaction() {
    const [isOpen, setIsOpen] = useState(false);
    const [isAdded, setIsAdded] = useState('');
    const [transactName, setTransactName] = useState('');
    const [amounts, setAmount] = useState(0);
    const [website, setWebsite] = useState('');

    const hour = new Date().getHours();
    const minute = new Date().getMinutes();
    const ampm = hour > 12 ? 'PM' : 'AM';
    const time = `${hour}: ${minute} ${ampm}`;

    const { addItemTransaction } = useContext(GlobalContext);

    const handleAddNewItem = (e) => {
        e.preventDefault();
        if (!transactName && !amounts && !website) return;
        const newItem = {
            id: Math.trunc(Math.random() * 100000000),
            text: transactName,
            amount: Number(amounts),
            website: website,
            time: time
        }
        addItemTransaction(newItem);
        setIsAdded('New Transaction Added');
        setTimeout(() => {
            setIsAdded();
        }, 1500)
        setTransactName('');
        setWebsite('');
        setAmount(0);
        setIsOpen(false);
    }

    return (
        <>
            {isAdded && <span className='added-alert'>{isAdded}</span>}

            {isOpen &&
                <form form onSubmit={handleAddNewItem} className="add-transaction-box">
                    <h3> Add new transaction</h3>
                    <label>Text</label>
                    <input
                        type="text"
                        placeholder="Enter text"
                        value={transactName}
                        onChange={(e) => setTransactName(e.target.value)}
                    />
                    <label>Amount</label>
                    <span className='note'>(Negative - expense, Positive + Income)</span>
                    <input
                        type="text"
                        placeholder="Enter amount"
                        value={amounts}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                    <label>Website</label>
                    <input
                        type="text"
                        placeholder="Website name"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                    />
                    <button>Add transaction</button>
                </form >}
            <button className='add-item' onClick={() => setIsOpen((s) => s = !s)}>
                {isOpen ? 'x' : '+'}
            </button>
        </>
    )
}